import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, onMounted, computed } from 'vue';
import useCollaboratorState from '@/app/collaborator/infrastructure/persistence/CollaboratorState';


export default /*#__PURE__*/_defineComponent({
  __name: 'InputCollaborators',
  props: ['modelValue'],
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props;

const state = useCollaboratorState();



const collaboratorOptions = ref<any[]>([]);
const selecteds = computed(() => {
    return collaboratorOptions.value.filter((item) => {
        return props.modelValue.includes(item.id);
    });
});

onMounted(async () => {
    collaboratorOptions.value = await state.getAllSimple();
});

function updateSelecteds(event: any) {
    const items = event.map((item: any) => {
        return item.id;
    });

    emit('update:modelValue', items);
}

return (_ctx: any,_cache: any) => {
  const _component_v_combobox = _resolveComponent("v-combobox")!

  return (_openBlock(), _createBlock(_component_v_combobox, {
    "model-value": _unref(selecteds),
    "onUpdate:modelValue": updateSelecteds,
    label: "Colaboradores",
    multiple: "",
    "return-object": "",
    chips: "",
    "item-title": "name",
    "item-value": "id",
    items: collaboratorOptions.value,
    "closable-chips": ""
  }, null, 8, ["model-value", "items"]))
}
}

})